import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-263469ee")

_pushScopeId("data-v-263469ee")
const _hoisted_1 = { class: "feed-edit" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("全部商品")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("主分类")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("商品标签")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("商品推荐")
const _hoisted_6 = {
  key: 0,
  class: "category"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("添加分类")
const _hoisted_8 = {
  key: 1,
  class: "tag"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("商品标签")
const _hoisted_10 = {
  key: 2,
  class: "tag"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("商品标签")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")
  const _component_el_form = _resolveComponent("el-form")
  const _component_FormSkeleton = _resolveComponent("FormSkeleton")
  const _component_FormFooter = _resolveComponent("FormFooter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("header", null, [
      _createVNode(_component_PageHeader, {
        title: _ctx.feedId ? '编辑Feed' : '新建Feed',
        router: "feed",
        type: "link"
      }, null, 8, ["title"])
    ]),
    _createVNode("main", null, [
      _createVNode(_component_FormSkeleton, {
        loading: _ctx.formDataLoading || _ctx.categoriesLoading
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form, {
            "label-position": "top",
            model: _ctx.formData,
            size: "medium",
            ref: "form"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_form_item, {
                style: {"width":"450px"},
                label: "Feed名称",
                rules: [
              {
                required: true,
                whitespace: true,
                message: '请输入Feed名称',
                trigger: 'blur',
              },
            ],
                prop: "name"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.name = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "选择商品" }, {
                default: _withId(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.formData.type,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.type = $event))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_radio, { label: "all" }, {
                        default: _withId(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: "category" }, {
                        default: _withId(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: "tag" }, {
                        default: _withId(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: "recommend" }, {
                        default: _withId(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_ctx.formData.type === 'category')
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode(_component_el_form_item, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addCategory('category')))
                        }, {
                          default: _withId(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formData.normalVal.category, (item, index) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "form-bg-item",
                        key: index
                      }, [
                        _createVNode(_component_el_form_item, {
                          prop: `normalVal.category.${index}.id`,
                          rules: [
                  {
                    required: true,
                    message: '请添加分类',
                    trigger: 'change',
                  },
                ]
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: item.id,
                              "onUpdate:modelValue": ($event: any) => (item.id = $event),
                              placeholder: "请选择",
                              style: {"width":"430px"}
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: category.id,
                                    label: category.base_name,
                                    value: category.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["prop"]),
                        _createVNode("i", {
                          class: "el-icon-delete",
                          onClick: ($event: any) => (_ctx.delCategory(index, 'category'))
                        }, null, 8, ["onClick"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.type === 'tag')
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode(_component_el_form_item, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addCategory('tag')))
                        }, {
                          default: _withId(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formData.normalVal.tag, (item, index) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "form-bg-item",
                        key: index
                      }, [
                        _createVNode(_component_el_form_item, {
                          prop: `normalVal.tag.${index}.id`,
                          rules: [
                  {
                    required: true,
                    message: '无效的商品标签',
                    trigger: 'change',
                  },
                ]
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_autocomplete, {
                              modelValue: item.base_name,
                              "onUpdate:modelValue": ($event: any) => (item.base_name = $event),
                              "fetch-suggestions": _ctx.searchTag,
                              placeholder: "请输入内容",
                              style: {"width":"430px"},
                              onSelect: ($event: any) => (_ctx.select($event, 'tag', index)),
                              onInput: ($event: any) => (_ctx.changeSearchKey(item))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "onSelect", "onInput"])
                          ]),
                          _: 2
                        }, 1032, ["prop"]),
                        _createVNode("i", {
                          class: "el-icon-delete",
                          onClick: ($event: any) => (_ctx.delCategory(index, 'tag'))
                        }, null, 8, ["onClick"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.type === 'recommend')
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _createVNode(_component_el_form_item, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addCategory('recommend')))
                        }, {
                          default: _withId(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formData.normalVal.recommend, (item, index) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "form-bg-item",
                        key: index
                      }, [
                        _createVNode(_component_el_form_item, {
                          prop: `normalVal.recommend.${index}.id`,
                          rules: [
                  {
                    required: true,
                    message: '无效的商品推荐',
                    trigger: 'change',
                  },
                ]
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_autocomplete, {
                              modelValue: item.base_name,
                              "onUpdate:modelValue": ($event: any) => (item.base_name = $event),
                              "fetch-suggestions": _ctx.serachRecommend,
                              placeholder: "请输入内容",
                              style: {"width":"430px"},
                              onSelect: ($event: any) => (_ctx.select($event, 'recommend', index)),
                              onInput: ($event: any) => (_ctx.changeSearchKey(item))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "onSelect", "onInput"])
                          ]),
                          _: 2
                        }, 1032, ["prop"]),
                        _createVNode("i", {
                          class: "el-icon-delete",
                          onClick: ($event: any) => (_ctx.delCategory(index, 'recommend'))
                        }, null, 8, ["onClick"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createVNode("footer", null, [
      _createVNode(_component_FormFooter, {
        onSave: _ctx.triggerSave,
        loading: _ctx.saveLoading
      }, null, 8, ["onSave", "loading"])
    ])
  ]))
})